module.exports = __webpack_public_path__ + "static/img/bg-apply.86b18b8.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/home/bg-apply.png
// module id = hOKp
// module chunks = 1